module.exports = __webpack_public_path__ + "static/img/location_bg.d3ef98a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/location_bg.png
// module id = 2tmL
// module chunks = 44